import React, { useState, useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { getApiData } from "../../utils/APIHelper";
import authActions from "../../redux/reducers/auth/actions";
import { store } from "../../redux/store/configureStore";
import OtpInputFields from "react-otp-input";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import useStyles from "./styles";
import { ReactComponent as Logo } from "../../assets/svg/Logo.svg";
import { ReactComponent as BackIcon } from "../../assets/svg/BackIcon.svg";

const OtpInput = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location?.state?.data ? location?.state?.data : {};
  const fromType = location?.state?.type ? location?.state?.type : "";
  const is2Fa = location?.state?.subtype
    ? location?.state?.subtype === "two_factor"
    : false;
  const dispatch = useDispatch();
  const { setUserData, setToken } = authActions;
  const { userData } = useSelector((state) => state.auth);
  const [output, setOutput] = useState("");
  const [timerCount, setTimer] = useState(60);
  const [btnLoad, setBtnLoad] = useState("");
  const [resendViewVisible, setResendViewVisible] = useState(false);

  useEffect(() => {
    console.log("userData", userData, locationState);
  }, [userData]);

  useEffect(() => {
    setOutput("");
  }, []);

  useEffect(() => {
    if (output?.length === 5) {
      OTPVerify(output);
    }
  }, [output]);

  useEffect(() => {
    if (timerCount === 0) {
      setResendViewVisible(true);
    }
    if (!timerCount) {
      return;
    }

    const intervalId = setInterval(() => {
      setTimer(timerCount - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timerCount]);

  async function OTPVerify(code) {
    setBtnLoad("otp");

    if (code === "") {
      toast.error("Enter code to proceed");
      return;
    }

    try {
      const response = await getApiData(`api/contractor/verify-otp`, "POST", {
        otp: code,
        user_id: userData?.id,
      });

      if (response.success) {
        // toast.success(response?.message);
        navigate("/role");
        return;
      } else {
        toast.error(response?.message);
        setOutput("");
      }

      setBtnLoad("");
    } catch (error) {
      console.error("OTP verification error:", error);
      toast.error(error.toString() || "Something went wrong! Please try again");
      setBtnLoad("");
    }
  }

  // this function resend otp to the user
  async function resendOtp() {
    setBtnLoad("resend");
    try {
      const response = await getApiData(`api/v1/user/resend-otp`, "POST", {
        user_id: userData?.id,
        verify_type: "email",
      });

      console.log("response ====resend otp=>>> ", response);
      if (response.success) {
        toast.success(response.message);
        setTimer(60);
        setResendViewVisible(false);
        setOutput("");
      } else {
        toast.error(response.message);
      }
      setBtnLoad("");
    } catch (error) {
      console.log("🚀 ~ file: index.js:88 ~ resendOtp ~ error:", error);
      toast.error(error.toString() || "Something gone wrong! Please try again");
      setBtnLoad("");
    }
  }

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: 'url("/assets/images/bg3.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          textAlign: "center",
          px: 3,
          pt: 10,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "30px",
            width: "50%",
          }}
        >
          <div>
            <Logo />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <BackIcon
              onClick={() => {
                store.dispatch(authActions.clearAllData());
                navigate("/login");
              }}
              style={{ cursor: "pointer" }}
            />
            <div
              style={{
                width: "100%",
                fontSize: "40px",
                fontFamily: "Inter Tight",
                textAlign: "center",
                fontWeight: "600",
                color: "#000000",
                letterSpacing: "-0.4px",
              }}
            >
              Enter OTP
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "55%",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <center>
              <OtpInputFields
                fullWidth
                value={output}
                onChange={setOutput}
                numInputs={5}
                renderSeparator={<span style={{ padding: 10 }}> </span>}
                renderInput={(props) => <input {...props} />}
                inputType="tel"
                inputStyle={{
                  height: 45,
                  width: 45,
                  fontSize: 20,
                  border: `1px solid #D7D8D9`,
                  borderRadius: 12,
                  textAlign: "center",
                }}
              />
            </center>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                marginTop: "3vh",
              }}
            >
              <button
                style={{
                  width: "fit-content",
                  padding: "1.5vh 4vw",
                  backgroundColor: "#4D6BF6",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  boxShadow: "none",
                  border: "1px solid transparent",
                  color: "#fff",
                  cursor: "pointer",
                  fontFamily: "Inter Tight",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
                onClick={() => {
                  if (btnLoad === "resend" || btnLoad === "otp") {
                    return null;
                  } else {
                    if (output) {
                      OTPVerify(output);
                    } else {
                      toast.error("Please enter one time password");
                    }
                  }
                }}
              >
                {btnLoad === "otp" ? (
                  <CircularProgress style={{ color: "#fff" }} size={26} />
                ) : (
                  "Confirm"
                )}
              </button>
            </div>

            <button
              style={{
                width: "fit-content",
                background: "#fff",
                fontSize: "12px",
                fontWeight: "500",
                boxShadow: "none",
                color: "#4D6BF6",
                border: "none",
                cursor: "pointer",
                fontFamily: "Inter Tight",
                whiteSpace: "nowrap",
                textAlign: "center",
                marginTop: "1vh",
              }}
              onClick={() => {
                if (
                  btnLoad === "resend" ||
                  !resendViewVisible ||
                  btnLoad === "otp"
                ) {
                  return null;
                } else {
                  resendOtp();
                }
              }}
            >
              {btnLoad === "resend" ? (
                <CircularProgress style={{ color: "#fff" }} size={26} />
              ) : resendViewVisible ? (
                "Resend OTP"
              ) : (
                `00:${timerCount}`
              )}
            </button>
          </div>
        </Box>
      </Box>
    </>
  );
};

export default OtpInput;
